// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"658":"07afb3ef","845":"92be4227"}[chunkId] + ".css";
};